<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full gap-4 p-10">
    <!-- Animated gradient ring -->
    <div class="relative size-16 flex items-center justify-center">
      <div
        class="absolute inset-0 rounded-2xl bg-brand-gradient opacity-[0.07]"
      />
      <span class="i-lucide-message-circle text-n-stone-300 size-7" />
    </div>

    <div class="flex flex-col items-center gap-1.5">
      <span class="text-[14px] font-semibold text-n-stone-500 text-center">
        {{ message }}
      </span>
      <span
        class="text-[12px] text-n-stone-300 text-center max-w-[280px] leading-relaxed"
      >
        Selecione uma conversa ao lado para começar
      </span>
    </div>

    <!-- Keyboard hint -->
    <div class="flex items-center gap-4 mt-2">
      <div class="flex items-center gap-1.5 text-n-stone-300 text-[11px]">
        <kbd
          class="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-white dark:bg-n-solid-3 border border-n-stone-200 rounded text-[10px] font-mono text-n-stone-400"
        >
          <span class="text-[9px]">&#8984;</span>K
        </kbd>
        <span>Comandos</span>
      </div>
      <div class="flex items-center gap-1.5 text-n-stone-300 text-[11px]">
        <kbd
          class="inline-flex items-center px-1.5 py-0.5 bg-white dark:bg-n-solid-3 border border-n-stone-200 rounded text-[10px] font-mono text-n-stone-400"
        >
          /
        </kbd>
        <span>Atalhos</span>
      </div>
    </div>
  </div>
</template>
